import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { Reveal, EASE } from "../lib/anim";

const CONTENTS = [
  "Toothbrush", "Toothpaste", "Bar soap", "Shampoo", "Deodorant", "Comb",
  "Washcloth", "Hand sanitizer", "Feminine hygiene products", "Body wipes",
];

const BENEFICIARIES = ["Low-income families", "Children", "Senior citizens", "Individuals experiencing homelessness", "Community clinic patients"];

export const KitInitiative = () => (
  <section id="kits" data-testid="kit-initiative" className="py-24 md:py-32 bg-[#F8FAFC] border-y hairline">
    <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-center">
      <Reveal className="order-2 lg:order-1">
        <p className="text-xs md:text-sm uppercase tracking-[0.2em] text-brand-blue font-bold mb-4">Current Program</p>
        <h2 className="font-display text-4xl md:text-5xl font-semibold tracking-tight text-brand-ink leading-tight">
          The Community Hygiene Kit Initiative
        </h2>
        <p className="mt-6 text-lg text-brand-ink/60 leading-relaxed">
          We assemble and distribute hygiene kits through community clinics and charitable organizations serving underserved
          populations — reinforcing healthy habits well beyond the clinic visit.
        </p>

        <div className="mt-8">
          <h3 className="text-sm font-bold uppercase tracking-wide text-brand-ink/50 mb-4">Each kit may include</h3>
          <div className="flex flex-wrap gap-2.5">
            {CONTENTS.map((item, i) => (
              <motion.span
                key={item}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, ease: EASE, delay: i * 0.04 }}
                className="inline-flex items-center gap-1.5 bg-white border hairline rounded-full pl-2.5 pr-3.5 py-1.5 text-sm text-brand-ink/80"
              >
                <Check className="h-3.5 w-3.5 text-brand-green" /> {item}
              </motion.span>
            ))}
          </div>
        </div>

        <div className="mt-8 pt-6 border-t hairline">
          <h3 className="text-sm font-bold uppercase tracking-wide text-brand-ink/50 mb-3">Primary beneficiaries</h3>
          <p className="text-brand-ink/70">{BENEFICIARIES.join(" · ")}</p>
        </div>
      </Reveal>

      <Reveal delay={0.1} className="order-1 lg:order-2">
        <div className="relative">
          <div className="aspect-[4/5] rounded-[2rem] overflow-hidden shadow-xl group">
            <img
              src="/photo-kits.webp"
              alt="AMCares hygiene kits laid out for distribution"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
            />
          </div>
          <div className="absolute -top-5 -right-5 bg-brand-green text-white rounded-2xl px-6 py-4 shadow-lg">
            <div className="font-display text-3xl font-semibold">10+</div>
            <div className="text-xs opacity-90">essentials per kit</div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
